import Authentication from './authentication'

const get = ( endpoint, data = null ) => {

    let token = Authentication.getToken()

    return fetch(data ? `https://home.adr1.fr/api${endpoint}?${data}` : `https://home.adr1.fr/api${endpoint}`, {
        method: 'GET',
        // credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization' : `Bearer ${token || null}`
        }
    }).then( res => res.json() )
}

const post = ( endpoint, data = null) => {
    
    let token = Authentication.getToken()

    return fetch(`https://home.adr1.fr/api${endpoint}`, {
        method: 'POST',
        // credentials: 'include',
        body: data ? JSON.stringify(data) : JSON.stringify({}),
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization' : `Bearer ${token || null}`
        }
    }).then( res => res.json() )
}

const put = ( endpoint, data = null) => {
    
    let token = Authentication.getToken()

    return fetch(`https://home.adr1.fr/api${endpoint}`, {
        method: 'PUT',
        // credentials: 'include',
        body: data ? JSON.stringify(data) : JSON.stringify({}),
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization' : `Bearer ${token || null}`
        }
    }).then( res => res.json() )
}

const delete_ = (endpoint) => {
    
    let token = Authentication.getToken()

    return fetch(`https://home.adr1.fr/api${endpoint}`, {
        method: 'DELETE',
        // credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization' : `Bearer ${token || null}`
        }
    }).then( res => res.json() )
}

export default {
    get,
    post,
    delete_,
    put
} 